import { render } from "./ArticleDetail.vue?vue&type=template&id=5366d290&scoped=true"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts"

import "./ArticleDetail.vue?vue&type=style&index=0&id=5366d290&lang=scss"
import "./ArticleDetail.vue?vue&type=style&index=1&id=5366d290&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5366d290"

export default script